import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/(marketing)/[locale]/error.tsx");
